import { Location } from '@angular/common';
import { Component, Inject, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { SecurityController } from '@shared/src/controllers/security/security.controller';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { HDateHour } from "@shared/src/datatypes/HDateHour";
import { HString } from '@shared/src/datatypes/HString';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SharedAsideFactory } from '../../aside/shared.aside.factory';
import { TruckingController } from '@shared/src/controllers/trucking/trucking.controller';
import { FilterTruckingRouteDto } from '@shared/src/dtos/trucking/FilterTruckingRouteDto';
import { SharedActiveRoutes } from '../../components.api';
import { TruckingRouteDto } from '@shared/src/dtos/trucking/TruckingRouteDto';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { OptionDto } from '@shared/src/dtos/maintenance/option/OptionDto';


@Component({
	selector: 'shared-trucking-routes',
	templateUrl: './shared.trucking.routes.html',
	styleUrls: ['./shared.trucking.routes.scss']
})
export class SharedTruckingRoutes implements OnInit {


	searchTextUpdate = new Subject<string>();

	public static SLICECOUNTINITIAL: number = 100;
	public static SLICECOUNTMORE: number = 100;

	public useIonic: boolean = false;
	constructor(public activatedRoute: ActivatedRoute,
		public router: Router, public location: Location, public truckingController: TruckingController,
		@Inject('HomeController') public homeController: HomeController,
		@Inject("SecurityController") public securityController: SecurityController,
		@Inject('SharedAsideFactory') public sharedAsideFactory: SharedAsideFactory,
		public socketController: SocketController,
		public translateService: TranslateService) {

		// Debounce search.
		this.searchTextUpdate.pipe(
			debounceTime(HomeController.DEFAULT_BOUNCE_BUTTON_TIME),
			distinctUntilChanged())
			.subscribe(value => {
				//Abans d'anar a la base de dades, hem de tenir mínim 3 digits o que el searchtext sigui "" (voldrà dir que borra tot per tornar a començar)
				if (HString.isNullOrNullString(this.searchText))
					this.loadData(true, false);
				else if (this.searchText.length > 2)
					this.loadExactKeyData(false);
			});

		if (homeController.useIonic)
			this.useIonic = homeController.useIonic();
		
		this.truckingController.refreshRouteList$.subscribe((data: boolean) => {
            if(data)
				this.loadData(true, false);
		});
		this.truckingController.refreshRouteSelected$.subscribe((data: TruckingRouteDto) => {
            this.routes.push(data);
			this.onClickItem(data);
			this.loadData(true, false);
		});
	}

	public searchText: string = "";
	public searchText2: string = "";

	public filterSearchByText: FilterTruckingRouteDto = FilterTruckingRouteDto.buildPage("", []);
	public routes: Array<TruckingRouteDto> = [];
	public routesExactKey: Array<TruckingRouteDto> = [];
	public filterMetadataExactKey: any = {};
	public filterMetadata: any = {};

  	public actions: ActionsStripDto = new ActionsStripDto();

	ngOnInit(): void {
		this.sliceCount = SharedActiveRoutes.SLICECOUNTINITIAL;
		this.loadFilters();
		this.loadData(true, false);
	}

	public filters: OptionsStripDto;
	public actualFilterId: string = "NOCONFIRMED";
	public loadFilters() {
		let result = new OptionsStripDto();
		
		result.add(OptionDto.build("NOCONFIRMED", "TRUCKING.ROUTE.FILTER.NOCONFIRMED.CAPTION", "TRUCKING.ROUTE.FILTER.NOCONFIRMED.HELP", "", 1, -1, 1, true, false));
		result.add(OptionDto.build("CONFIRMED", "TRUCKING.ROUTE.FILTER.CONFIRMED.CAPTION", "TRUCKING.ROUTE.FILTER.CONFIRMED.HELP", "", 2, -1, 1, false, false));
		result.add(OptionDto.build("PREDEFINED", "TRUCKING.ROUTE.FILTER.PREDEFINED.CAPTION", "TRUCKING.ROUTE.FILTER.PREDEFINED.HELP", "", 3, -1, 1, false, false));
		result.add(OptionDto.build("ALL", "TRUCKING.ROUTE.FILTER.ALL.CAPTION", "TRUCKING.ROUTE.FILTER.ALL.HELP", "", 4, -1, 1, false, false));

		this.actualFilterId = result.getActualSelected().optionId;
		this.filters = result;
	}

	onFilterUpdate(option: OptionDto) {
		this.actualFilterId = option.optionId;
		this.selectedRoute = null;
		this.loadData(true, true);
	}

	public _routeId: number;
	public get routeId(): number {
		return this._routeId;
	}
	public set routed(value: number) {
		if (this._routeId === value)
			return;
		this._routeId = value;
	}

	ngAfterViewChecked(): void {
	}


	loadFilterOfSearchByText() {
		if (!HString.isNullOrNullString(this.actualFilterId)){
			this.filterSearchByText.filterKeys = new Array();
			this.filterSearchByText.filterKeys.push(this.actualFilterId);
		}
	}

	loadExactKeyData(forcedsearch: boolean) {

		this.loadFilterOfSearchByText();

		if (!HString.isNullOrNullString(this.searchText)) {
			this.routesExactKey = new Array();
			this.filterSearchByText.searchText = this.searchText;
			this.truckingController.getTruckingRoutesExactKey(this.filterSearchByText).subscribe(data => {

				if (data == null) {
					this.routesExactKey = new Array();
					return;
				}
				this.routesExactKey = data.routes;
			});
		}
		else {
			this.routesExactKey = new Array();
		}
		this.loadData(true, false);
	}

	public loading: boolean = false;
	loadData(forcedsearch: boolean, busy: boolean) {

		//QUAN COMENCEM A BUSCAR, posem el searchtext2 igual al searchText per a que doni la sensació que busca
		this.searchText2 = this.searchText;

		//Si tenim route seleccionat, no te sentit fer cerca total
		if (!forcedsearch && this.routeId > 0)
			return;

		this.loadFilterOfSearchByText();

		this.filterSearchByText.searchText = this.searchText;
		this.filterSearchByText.idReserca = HDateHour.toStringSorteable(HDateHour.now());
		this.filterSearchByText.sliceCount = this.sliceCount;
		this.truckingController.getTruckingRoutes(this.filterSearchByText).subscribe(data => {

			if (data == null) {
				this.routes = new Array();
				return;
			}

			//Si no es la última petició feta, obiem la resposta
			if (!HString.equals(data.idReserca, this.filterSearchByText.idReserca)) {
				return;
			}

			this.routes = data.routes;

			this.routesCount = data.routeAllCount;
			if (this.routes != null) {
				this.itemsCount = data.routeAllCount;

				//comprovem si la seleccionada encara esta
				if (this.selectedRoute != null) {
					let findselected = false;
					let i = 0;
					while (i < this.routes.length) {
						if (this.routes[i].routeId === this.selectedRoute.routeId) {
							findselected = true;
							this.selectedRoute = this.routes[i];
						}
						if (findselected) {
							i = this.routes.length;
						}
						i++;
					}
					//Si la seleccionada ja no està a la llista, la resetejem
					if (!findselected)
						this.onClickItem(null);
				}
			} else {
				this.onClickItem(null);
			}

			this.loadFilterOfSearchByText();

			//Quan acabem de buscar ja no cal filtrar en local, ja ho ha fet el servidor
			this.searchText2 = "";

			this.loadActions();
		});
	}

	loadActions(){
		let tactions: ActionsStripDto = new ActionsStripDto();

		tactions.add(ActionDto.buildBase("NEWROUTE", "TRUCKING.ROUTE.ACTION.NEWROUTE.CAPTION", "TRUCKING.ROUTE.ACTION.NEWROUTE.HELP", "fa-plus-square", 1, 0, 1, "", "action-GO"));

		this.actions = tactions;
	}

	onClickAction(action: ActionDto) {
        
        if (action != null) {
            if (action.actionId == "NEWROUTE") {
                this.truckingController.createEmptyRoute().subscribe(data => {
                    this.routes.push(data);
                    this.onClickItem(data);
                    this.loadData(true, false);
                });
            } 
        }
    }

	public routesCount: number = 0;
	public _selectedRoute: TruckingRouteDto;
	@Input()
	public get selectedRoute(): TruckingRouteDto {
		return this._selectedRoute;
	}
	public set selectedRoute(value: TruckingRouteDto) {
		if (this._selectedRoute === value)
			return;
		this._selectedRoute = value;
		this._routeId = value != null ? value.routeId : 0;
		this.loadActions();
		this.onRefreshRoute(this.selectedRoute);
	}

	public itemsCount = 0;
	public sliceCount: number = SharedActiveRoutes.SLICECOUNTINITIAL;
	public onSliceMore() {
		this.sliceCount = this.sliceCount + SharedActiveRoutes.SLICECOUNTMORE;
		this.loadData(true, false);
	}

	pretty(value) {
		return JSON.stringify(value);
	}


	onSearchFocus(event: any) {
		if (event && event.stopPropagation)
			event.stopPropagation();

	}

	onSearchClick(event: any) {
		if (event && event.stopPropagation)
			event.stopPropagation();
	}



	@Output() clickItem = new EventEmitter<TruckingRouteDto>();
	onClickItem(item: TruckingRouteDto) {
		if (item == null) {
			this.selectedRoute = null;
			this.clickItem.next(this.selectedRoute);
			return;
		}
		this.selectedRoute = item;
		this.clickItem.next(this.selectedRoute);
	}

	onClickBack(refresh: boolean) {
		this.selectedRoute = null;
		if (refresh || this.routes == null || this.routes.length == 0)
			this.loadData(true, false);
	}

	onNewRoute(event) {
		this.truckingController.createEmptyRoute().subscribe(data => {
			this.routes.push(data);
			this.onClickItem(data);
			this.loadData(true, false);
		});
	}
	
	getRoutes(){
		if(this.routes == null)
			return new Array();
		return this.routes;
	}
	onRefreshRoute(item: TruckingRouteDto) {

		let finditem = false;
		let findselected = false;

		let i = 0;
		if(item){
			let newList = new Array();
			while (i < this.routes.length) {
				if (this.routes[i].routeId === item.routeId) {
					newList.push(item);
				}else{
					newList.push(this.routes[i]);
				}
				i++;
			}
			this.routes = newList;
		}
		i = 0;
		while (i < this.routes.length) {
		
			if (this.selectedRoute && this.routes[i].routeId === this.selectedRoute.routeId) {
				findselected = true;
				this.selectedRoute = this.routes[i];
			}
			if (findselected && finditem) {
				i = this.routes.length;
			}
			i++;
		}
		//Si la seleccionada ja no està a la llista, la resetejem
		if (!findselected)
			this.selectedRoute = null;
		
	}
	
}
